const NotFound = () => (
  <div className="c7-404">
    <h1>Sorry about that</h1>
    <p>Okay that wasn&apos;t great, the page you are looking for is missing.</p>
  </div>
);

export default NotFound;
